export default "/Frontend/dist/image.27473c73cf83f7857d73a4ac19c4e1e0.svg";